/**
 * UKG Availability Type IDs used when creating schedule pattern items during rollout.
 * These values correspond to the availabilityType.id in the UKG API payload.
 */

const Unavailable = 'Unavailable';
const Available = 'Available';
const PreferredAvailable = 'PreferredAvailable';
const PreferredUnavailable = 'PreferredUnavailable';

export const AvailabilityType = Object.freeze({
    [Unavailable]: 1,
    [Available]: 3,
    [PreferredAvailable]: 4,
    [PreferredUnavailable]: 5,
});

export const AvailabilityTypeKeys = Object.freeze({
    1: Unavailable,
    3: Available,
    4: PreferredAvailable,
    5: PreferredUnavailable,
});

